import { render, staticRenderFns } from "./customers.vue?vue&type=template&id=01a387a4&scoped=true&"
import script from "./customers.ts?vue&type=script&lang=ts&"
export * from "./customers.ts?vue&type=script&lang=ts&"
import style0 from "./customers.styl?vue&type=style&index=0&id=01a387a4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a387a4",
  null
  
)

export default component.exports